const sendCometlyEvent = (
    eventName: string,
    applicationId?: string,
    emailAddress?: string,
) => {
    if (
        window?._env_?.ENV?.toUpperCase() !== 'PRODUCTION' ||
        typeof window.comet !== 'function' ||
        !applicationId
    ) {
        return;
    }

    try {
        window.comet(eventName, {
            tracking_id: applicationId,
            email: emailAddress,
        });
    } catch (error) {
        console.error('Failed to send Cometly event', error);
    }
};

export const trackCometlyFactFindStarted = (
    applicationId?: string,
    emailAddress?: string,
) => sendCometlyEvent('custom_event_3', applicationId, emailAddress);

export const trackCometlyFactFindSubmitted = (
    applicationId?: string,
    emailAddress?: string,
) => sendCometlyEvent('custom_event_4', applicationId, emailAddress);
